import * as moment from "moment";

export interface IIndexedCase {
  caseId: string;
  childId: string;
  agencyCode: string;
  status: string;
  type: string;
  city: string;
  state: string;
  country: string;
  portrait: string;
  fullName: string;
  missingSince: any;
  public: boolean;
  children: Array<{
    childId: string;
    fullName: string;
    images: any;
  }>;
  birthDate: any;
  openDate: any;
  circumstances: string;
  agenciesAccess?: string[];
}

export type Sort = Array<{ [key: string]: "asc" | "desc" }> | string[];

export interface IRequestCases {
  sort: Sort;
  sortName: string;
  page: number;
  size: number;
  search: string;
  isAppended?: boolean;
  status?: string;
  isPublic?: boolean;
  range: any;
  createdDateRange?: {
    startDate: moment.Moment | null;
    endDate?: moment.Moment | null;
  };
  isRouteState: boolean;
}

export const initialCasesViewOptions: IRequestCases = {
  page: 0,
  size: 24,
  sort: [{ missingSince: "desc" }, { fullName: "desc" }],
  search: "",
  range: null,
  isAppended: false,
  sortName: "missingSince",
  isRouteState: false
};

export interface IRequestCasesSearch {
  status?: string;
  isPublic?: boolean;
  sort: Array<{ [key: string]: { order: "asc" | "desc" } }>;
  range: { missingSince: { gte: string; lte: string } } | null;
  sortName?: string;
  search: string;
  page: string;
  size: string;
}
export interface IResponseCases {
  cases: {
    total: number;
    results: IIndexedCase[];
  };
}
export interface IResponseCount {
  open: number;
  restricted: number;
  all: number;
  closed: number;
}
export const initialResponseCount = {
  open: 0,
  restricted: 0,
  all: 0,
  closed: 0
};



// WEBPACK FOOTER //
// ./src/share/types/case/searchCase.ts